// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CuiButtonComponent } from '@coa/app/shared/button/cui-button.component';

@NgModule({
  declarations: [
    CuiButtonComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
  ],
  exports: [
    CuiButtonComponent,
  ],
})
export class CuiButtonModule {
}
